<xvi-xux-form-panel
  [title]="gridTitleObs | async"
  [titleTips]="gridTitleTipsObs | async"
  [description]="descriptionObs | async"
  [panelId]="field.widgetData?.groupId"
  [ngClass]="field.class"
  [class.panel-header-padding]="!field?.description"
>
  <xvi-toolbar
    panel-heading-content
    [buttons]="headerButtons"
    [click]="handleHeaderButtonClick"
  >
  </xvi-toolbar>

  <xvi-label-block panel-body-content [labels]="(topLabels | async) || []"></xvi-label-block>
  <xvi-label-block panel-body-content [labels]="warningLabels || []"></xvi-label-block>
  <xux-grid
    panel-body-content
    class="xux-list"
    [columns]="gridColumns"
    [items]="initXuxGridItems"
    [view]="gridView"
    [options]="gridOptions"
    [userGridOptions]="userGridOptions"
    [showLoader]="field.widgetData?.showLoader | async"
    [buttons]="gridButtons"
    [rowButtons]="rowButtons"
    [userComponents]="dmCustomGridComponents"
    [pinnedTopRowData]="pinnedTopRowData"
    [class.disabled]="disabled"
    (action)="onGridAction($event)"
    [i18n]="staticI18nTextContent.xuxGrid"
  >
  </xux-grid>

  <xvi-error-block
    panel-body-content
    [control]="field?.control"
    [showPristineErrors]="showPristineErrors"
  ></xvi-error-block>
</xvi-xux-form-panel>
